var exports = {
  "iE": "x31de4314--217f1b--wrapper",
  "$m": "x31de4314--217f1b--serp",
  "fA": "x31de4314--217f1b--serp--light",
};

module.exports = exports;
